import SeasonalTicketZonesSelector from './SeasonalTicketZonesSelector';

export default SeasonalTicketZonesSelector;
